<ng-container *ngIf="modalloader else showdata">
    <div class="imgloader">
        <img src="../../assets/img/loader.gif">
    </div>
</ng-container>
<ng-template #showdata>

<div class="container-fluid">

    
        <div class="row col-cutome-mng1">
            <!-- Left Sidebar -->

            <div class="col-md-3 " [ngClass]="showleftMenu?'':'d-none'">
            <div class="oi-doc-left-nav d-flex align-items-start flex-column" >
                

                <div class="oi-doc-left-nav-man" *ngIf="showleftMenu">
                    <h5>Documents <span>20</span></h5>
                   
                
                  
                    <div class="kh-left-nav-search d-flex justify-content-start">
                        <input type="text" id="search" name="search" class="search-field" [(ngModel)]="searchTerm" placeholder="Search by name" (ngModelChange)="searchByName()">
                        <button type="button" class="btn btn-search" (click)="searchByName()"><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" /><path d="M21 21l-6 -6" /></svg></button>
                    </div>

                    <div class="kh-links-mn1">                
                    <div *ngIf="!loader; else loading">
                        <div class="kh-link-inner-bx">
                            <ng-container *ngIf="filteredDocuments.length > 0; else noResults">
                                <ul *ngIf="filteredDocuments.length > 0">
                                  <li class="left-kh-nav-link" *ngFor="let file of filteredDocuments" [ngClass]="{'selected-document': file.file_name === file_name}">
                                    <a (click)="onClickfile(file)" class="d-flex justify-content-start" >
                                      
                                      <div class="text" [innerHTML]="file.file_name| highlight:searchTerm"></div>
                                      <div class="icon"><span *ngIf="file.isBookmarked"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2a5 5 0 0 1 5 5v14a1 1 0 0 1 -1.555 .832l-5.445 -3.63l-5.444 3.63a1 1 0 0 1 -1.55 -.72l-.006 -.112v-14a5 5 0 0 1 5 -5h4z" /></svg></span></div>
                                    </a>
                                  </li>
                                </ul>
                              </ng-container>
                              <ng-template #noResults>
                                <p>No documents found for the applied filters.</p>
                              </ng-template>
                        </div>
                        <div *ngIf="filteredDocuments.length > 0" class="kh-pagination-lft">
                         
                        </div>
                        
                    </div>
                    </div>

                      <ng-template #loading>
                        <div class="imgloader">
                          <img src="../../assets/img/loader.gif">
                        </div>
                      </ng-template>
                      <div class="oi-doc-staus-fld d-none">
                        <label>Showing:</label>
                        <select class="form-select" id="filterStatus" [(ngModel)]="selectedStatus" (change)="applyFilters()">
                          <option value="All" selected>All</option>
                          <option *ngFor="let status of statuses" [value]="status">{{ status }}</option>
                        </select>
                        <!-- <button type="button" class="btn btn-primary btn-sm" (click)="applyFilters()">Apply Filters</button> -->
                      </div>
                    
                </div>

                <div class="oi-doc-addbtn-bottom mt-auto">
                    <div class="addnew-btn">
                        <button class="btn btn-custome3" (click)="uploadDoc($event, documentName)">
                            <i class="bi bi-plus"></i> Add New
                        </button>
                    </div>
                </div>
                
                  
            </div>
            </div>
            

            <div class="col-md-1">
            <div class="align-border">
                <div class="move-arrow" [ngClass]="{'collapsed': !showleftMenu}"(click)="collapseLeftNav()"><img src="../../assets/img/right-arrow.svg"></div>
            </div>
            </div>

            <!-- Main Content Area -->
            <div class="col-md-8 content m-d-flex" [ngClass]="showleftMenu?'':'col-md-12'">

                <div class="oi-doc-tabmn">
                        <!-- Tabs for Different Sections -->
                <div class="oi-doc-view-tab">
                    <ul class="nav nav-tabs" id="documentTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" id="document-tab" data-bs-toggle="tab" href="#document" role="tab" aria-controls="document" aria-selected="true">Document View</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="metadata-tab" data-bs-toggle="tab" href="#metadata" role="tab" aria-controls="metadata" aria-selected="true">Meta Data</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="answers-tab" data-bs-toggle="tab" href="#answers" role="tab" aria-controls="answers" aria-selected="false" (click)="generateAnswers()">GenAns</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="knowledge-gap-tab" data-bs-toggle="tab" href="#knowledge-gap" role="tab" aria-controls="knowledge-gap" (click)="getKnowledgegapQn()" aria-selected="false">Knowledge Gaps</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="versions-tab" data-bs-toggle="tab" href="#versions" role="tab" aria-controls="versions" aria-selected="false" (click)="getVersion()">Versions </a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="keyword-log-tab" data-bs-toggle="tab" href="#keyword-log" role="tab" aria-controls="keyword-log" aria-selected="false" (click)="getkeywordSearch()">Key Word search Log</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="audit-log-tab" data-bs-toggle="tab" href="#audit-log" role="tab" aria-controls="audit-log" aria-selected="false" (click)="getAuditlog()">Audit</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="related-docs-tab" data-bs-toggle="tab" href="#related-docs" role="tab" aria-controls="related-docs" aria-selected="false" (click)="getRlatedDoc()">Related Documents</a>
                        </li>
                    </ul>
                    </div>
    
                    <div class="oi-tabmn-content tab-content mt-3">

                        <div class="tab-pane fade show active" id="document" role="tabpanel" aria-labelledby="document-tab">
                                <!-- Document Overview -->
                <div class="oi-doc-view-top d-flex justify-content-between align-items-center">
                    <h2 ><u (click)="goToCollection()">{{documentName}} <i class="bi bi-chevron-right"></i></u> {{file_name}} </h2>
                    <div class="oi-doc-view-btn-top">
                        <button *ngIf="isEditMode" (click)="cancelEdit()" class="btn btn-secondary cancelbtn-kh1">
                            Cancel
                        </button>
                        <button type="submit" class="btn btn-primary save-kh1" (click)="onSaveClick()" *ngIf="isEditMode">Save</button>
                    
                        <button class="btn btn-primary editmn1 btn-sm" *ngIf="!isEditMode" (click)="fetchFilecontent(documentId,true)"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /></svg> Edit</button>
                        <button class="btn btn-warning btn-sm d-none"><i class="bi bi-archive"></i> Archive</button>
                        <div class="btn-group">
                            <button type="button" class="btn btn-warning btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                Export
                            </button>
                            <ul class="dropdown-menu">
                                <li ><a class="dropdown-item" (click)="onDownload(selectedfilecontent.content, 'pdf')" ><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" /><path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" /><path d="M17 18h2" /><path d="M20 15h-3v6" /><path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z" /></svg> Export for PDF file</a></li> 

                                <!-- <li><a class="dropdown-item" (click)="onDownload(selectedfilecontent.content, 'docx')" ><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" /><path d="M2 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z" /><path d="M17 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0" /><path d="M9.5 15a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z" /><path d="M19.5 15l3 6" /><path d="M19.5 21l3 -6" /></svg> Export for DOCX file</a></li>  -->

                                <li><a class="dropdown-item" (click)="downloadRTFFile()" ><svg  xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M14 3v4a1 1 0 0 0 1 1h4" /><path d="M16.5 15h3" /><path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" /><path d="M4.5 15h3" /><path d="M6 15v6" /><path d="M18 15v6" /><path d="M10 15l4 6" /><path d="M10 21l4 -6" /></svg> Export for Text file</a></li>
                            </ul>
                        </div>
                        <button class="btn btn-outline-secondary btn-sm bookmrk1 " [ngClass]="isbookmarked?'active-bookmark':''" (click)="fnBookmark()"><i class="bi bi-bookmark"></i> Bookmark</button>
                    </div>
                </div>

                <!-- Document Preview -->
                <div class="document-preview">

                    <div class="oi-ad-collect-mdl khdoc">
                        
                        
                            <div class="modal-content documnttext">
                                <div class="kh-text-bx" *ngIf="isEditMode">
                
                                    <!-- <div *ngIf="isPreviewMode">
                                        <div [innerHTML]="sanitizeMessage(editableDocument.content)"></div>
                                        <div class="col-md-12">
                                            <button (click)="togglePreview()" class="btn btn-secondary privew-btn">
                                                {{ isPreviewMode ? 'Edit' : 'Preview' }}
                                            </button>
                                        </div>
                                    </div> -->
                                    <form *ngIf="!isPreviewMode" #editForm="ngForm" (ngSubmit)="onSaveClick()">
                                        <div class="form-group">
                                            <md-editor [(ngModel)]="editableDocument.content" name="content" [options]="editorOptions"
                                                [mode]="mode" ></md-editor>
                                        </div>
                                        <div class="oi-document-mdl-submt">
                                            <div class="row">
                
                                                <div class="col-md-12">
                                                <!-- <div class="sav-cancel-mn-btn">
                                                    <button (click)="cancelEdit()" class="btn btn-secondary cancelbtn-kh1">
                                                        Cancel
                                                    </button>
                                                    <button type="submit" class="btn btn-primary save-kh1">Save</button>
                                                </div> -->
                                                </div>
                                            </div>
                
                                        </div>
                                    </form>
                                </div>
                                <div #contentToConvert  *ngIf="!isEditMode">
                                    <div [innerHTML]="sanitizeMessage(selectedfilecontent.content)"></div>                                
                                </div>
                            </div>
                    </div>
                    

                    <!-- Add preview content dynamically -->

                </div>
                        </div>



                        <!-- Meta Data Tab -->
                        <div class="tab-pane fade" id="metadata" role="tabpanel" aria-labelledby="metadata-tab">
                            <div *ngIf="metadata==null" class="text-center">
                                No data available
                            </div>
                            <ul class="list-group" *ngIf="metadata!=null">
                                <li class="list-group-item"><strong>Author:</strong><span>  </span>  {{metadata?.username}} </li>
                                <li class="list-group-item"><strong>Keywords:</strong><span>  </span>  {{metadata?.tags}} </li>
                                <li class="list-group-item"><strong>Summary:</strong> <span>  </span> {{metadata?.summary}}</li>
                                <li class="list-group-item"><strong>Category:</strong>  <span>  </span>     
                                        <span *ngFor="let category of categoryPath; let isLast = last">
                                    {{ category.name }}<span *ngIf="!isLast"> -> </span>
                                  </span> </li>
                                <li class="list-group-item"><strong>Classification:</strong><span>  </span> </li>
                                <li class="list-group-item"><strong>Language:</strong> <span>  </span> </li>
                            </ul>
                        </div>
    
                        <!-- Generative Answers Tab -->
                        <div class="tab-pane latest-tab fade" id="answers" role="tabpanel" aria-labelledby="answers-tab">
                           
                            <div *ngIf="generateqns.length === 0" class="text-center">
                                No data available
                            </div>
                            
                            <div class="table-responsive" *ngIf="generateqns.length > 0">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Question</th>
                                            <th>Date</th>
                                            <th>Feedback</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Dynamic content goes here -->
                                        <tr *ngFor="let data of generateqns">
                                            <td class="oi-kgap" (click)="viewQuest(data.id)">{{data.question}}</td>
                                            <td><div class="oi-generativans-date">{{data.updated_at |  date: 'dd-MM-yyyy' : 'UTC'}}</div></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
    
                        <!-- Knowledge Gaps Tab -->
                        <div class="tab-pane fade" id="knowledge-gap" role="tabpanel" aria-labelledby="knowledge-gap-tab">
                            <div *ngIf="knowledgegpaDetail.length === 0" class="text-center">
                                No data available
                            </div>
                            <div class="table-responsive"  *ngIf="knowledgegpaDetail.length > 0">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Question</th>
                                            <th>Gap Type</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Dynamic content goes here -->
                                        <tr *ngFor="let data of knowledgegpaDetail">
                                            <td class="oi-kgap" (click)="viewQuest(data.id)">{{data.question}}</td>
                                            <td></td>
                                            <td>{{data.updated_at | date: 'dd-MM-yyyy'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
    
                        <!-- Versions Tab -->
                        <div class="tab-pane fade" id="versions" role="tabpanel" aria-labelledby="versions-tab">
                            <div *ngIf="versionDetail.length === 0" class="text-center">
                                No data available
                            </div>
                            <div class="table-responsive"  *ngIf="versionDetail.length > 0" >
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Version</th>
                                            <th>Created By</th>
                                            <th>Created On</th>
                                            <th>Description</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Dynamic content goes here -->
                                        <tr *ngFor="let version of versionDetail">
                                            <td>{{version.version}}</td>
                                            <td></td>
                                            <td>{{version.created_at |  date: 'dd-MM-yyyy'}}</td>
                                            <td></td>
                                            <td>
                                                <button class="btn btn-sm btn-custome1" (click)="viewVersion(version.id,true)"><i class="bi bi-eye"></i> View</button>
                                                <button class="btn btn-sm btn-secondary" (click)="viewVersion(version.id,false)"><i class="bi bi-download"></i> Download</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
    
                        <!-- Keyword Searches Log Tab -->
                        <div class="tab-pane fade" id="keyword-log" role="tabpanel" aria-labelledby="keyword-log-tab">
                            <div *ngIf="keywordSearchlogs.length == 0" class="text-center">No Data available</div>
                            <div class="table-responsive"  *ngIf="keywordSearchlogs.length > 0">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Keyword</th>
                                            <th>Matching Phrase</th>
                                        </tr>
                                    </thead>
                                    <tbody>                                    
                                        <tr  *ngFor="let data of keywordSearchlogs">
                                            <td>{{data.timestamp | date: 'dd-MM-yyyy'}}</td>
                                            <td>{{data.searched_keyword}}</td>
                                            <td  [innerHTML]="sanitizeMessage(data.search_result)"></td>
                                        </tr>
                                    </tbody>
                                </table> 
                            </div>
                        </div>
    
                        <!-- Audit Log Tab -->
                        <div class="tab-pane fade" id="audit-log" role="tabpanel" aria-labelledby="audit-log-tab">
                            <div *ngIf="auditDetail.length === 0" class="text-center">
                                No data available
                            </div>
                            <div class="table-responsive" *ngIf="auditDetail.length > 0"  >
                                <table class="table table-bordered">
                                    <thead>
                                        <tr >
                                            <th>Action</th>
                                            <th>Performed By</th>
                                            <th>Timestamp</th>
                                            <th>Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Dynamic content goes here -->
                                        <tr *ngFor="let log of auditDetail">
                                            <td>{{log.action}}</td>
                                            <td>{{log.performed_by}}</td>
                                            <td>{{log.timestamp |date: 'dd-MM-yyyy hh:mm:ss'}}</td>
                                            <td>{{log.details}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
    
                        <!-- Related Documents Tab -->
                        <div class="tab-pane fade" id="related-docs" role="tabpanel" aria-labelledby="related-docs-tab">
                            <div *ngIf="relatetedDocList.length === 0" class="text-center">
                                No data available
                            </div>
                            <div class="table-responsive" *ngIf="relatetedDocList.length > 0">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Document Name</th>
                                            <th align="center" class="realtd-act" width="60px">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Dynamic content goes here -->
                                        <tr *ngFor="let data of relatetedDocList">
                                            <td ><a  class="oi-kgap" (click)="openReldoc(data)" >{{data.document_name}}</a></td>
                                            <td align="center">
                                                <button class="btn btn-delt" (click)="deletedoc(data.id)"><svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <button class="btn btn-custome2" (click)="addReleteDoc()"><i class="bi bi-plus"></i> Add New</button>
                        </div>
                    </div>
                </div>




            

            
            </div>
        </div>
</div> 
</ng-template>
<app-file-upload-modal
  [(visible)]="showuploadmodal"
  [files]="files"
  [uploadLoader]="uploadloader"
  (fileSelected)="handleFileSelection($event)"
  (fileUploaded)="handleFileUpload()"
  (fileDeleted)="handleFileDelete($event)">
</app-file-upload-modal>
<p-dialog [(visible)]="showSelect" [modal]="true" [closable]="false" header="Multiple Select" [style]="{width: '50vw',height:'380px'}">
    <div class="multi-select-doc1">
      <p-multiSelect
        [options]="DocumentList"
        [(ngModel)]="selectedDocuments"
        optionLabel="label"
        placeholder="Select Documents"
        [filter]="false"
        [showHeader]="false" 
      ></p-multiSelect>
    </div>
  
    <ng-template pTemplate="footer">
      <button type="button" class="btn btn-secondary cancel-custom1 mr-15" (click)="closeselectModal()">Close</button>
      <button type="button" class="btn btn-primary save-custom1" (click)="saveSelection()">Save</button>
    </ng-template>
  </p-dialog>
  <p-dialog [(visible)]="viewversion" [header]="selectedVersionfilecontent?.file_name" [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    (onHide)="onDialogHideaddcollection()">
    <div class="oi-ad-collect-mdl khdoc">
        <ng-container *ngIf="versionmodalloader else showversionContent">
            <div class="imgloader">
                <img src="../../assets/img/loader.gif">
            </div>
        </ng-container>
        <ng-template #showversionContent>
            <div class="modal-content documnttext">
                <div >
                    <div [innerHTML]="sanitizeMessage(selectedVersionfilecontent.content)"></div>
                </div>
            </div>
        </ng-template>
    </div>

</p-dialog>


<p-toast></p-toast>